<template>
    <div class="p-4">
        <div class="vx-row">
            <div v-for="(i, index) in marketplaceList" :key="index" class="vx-col w-full lg:w-1/2 xl:w-1/2">
              <div :class="{'mb-base': (index == 0 || index == 1)}">
                <marketplace-item :marketplaceData="i" />
              </div>
            </div>
          </div>
    </div>
</template>

<script>
import MarketplaceItem from '../components/MarketplaceItem.vue';
export default {
    components: {
        MarketplaceItem
    },
    data() {
        return {
            marketplaceList: [
                { title: 'Editor', color: '#F2C244', description: '', icon: require('@/assets/images/icons/app-marketplace/editor.svg') },
                { title: 'Resume Parser', color: '#F2C244', description: 'PARSER is an AI assistant that reads your existing resume and suggests you the corresponding conversion in the editor. Activate and upload your resume.', icon: require('@/assets/images/icons/app-marketplace/resume-parser.svg') },
                { title: 'ALEX', color: '#F53855', description: 'ALEX is a microlearning assistant that triggers relevant content based on your career oriented development needs to help you form mini habits.', icon: require('@/assets/images/icons/app-marketplace/alex.svg') }
            ]
        }
    }
}
</script>

<style scoped>

</style>